import { TranslateService } from '@ngx-translate/core';
import { addNotification } from '../../../+state/notifications/notifications.actions';
import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  constructor(private _translate: TranslateService) {}

  handleSuccessNotification(translateKey: string) {
    return addNotification({
      notification: {
        type: 'success',
        title: this._translate.instant(`${translateKey}.title`),
        message: this._translate.instant(`${translateKey}.message`),
        createdAt: new Date(),
        liveTime: environment.notificationsLiveTime,
      },
    });
  }
}
